import { render, staticRenderFns } from "./ClientSearchReplace.vue?vue&type=template&id=ae32666a&scoped=true&"
import script from "./ClientSearchReplace.vue?vue&type=script&lang=js&"
export * from "./ClientSearchReplace.vue?vue&type=script&lang=js&"
import style0 from "./ClientSearchReplace.vue?vue&type=style&index=0&id=ae32666a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae32666a",
  null
  
)

export default component.exports